import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy route kept only so the router plugin doesn't produce a stale entry.
// Redirect to the main app.
export const Route = createFileRoute('/about')({
  beforeLoad: () => {
    throw redirect({ to: '/chat', replace: true });
  },
});
